/* eslint-disable @typescript-eslint/naming-convention */
import { ActivityType } from '../constant/activity-constants/activity-type.constants';
import { DateTimeHelper, DateTimeType } from '../utils/date-time-helper';

export class Activity {
    RecordId?: number;

    Id?: number;
    CreatedBy?: number;
    CreatedDate?: string;
    ModifiedBy?: number;
    ModifiedDate?: string;
    ActivityLogId?: number;
    ReferenceId?: number | null;

    UserId: number;
    Text: string;
    Type: ActivityType;
    ActivityLogRecordId: number;
    AttachCount: number;
    ReferenceRecordId?: number;
    EntityTypeId?: number;
    IsDeleted: boolean;
    IsArchived: boolean;
    UserSpecifiedDate: string;
    UserSpecifiedDateOffset?: number;
    TimeZoneId: string;
    Longitude?: number;
    Latitude?: number;

    constructor(obj?: Partial<Activity>) {
		if (obj) {
				Object.assign(this, obj);
		}
		else {
			throw Error('Object cannot be null');
		}
	}

    clone(): Activity {
        return new Activity(this);
    }

    setText(text: string): void {
        this.Text = text;
    }

    setCoordinates(longitude?: number, latitude?: number): void {
        this.Longitude = longitude;
        this.Latitude = latitude;
    }

    setActivityDate(activityDate: DateTimeType, timeZoneId: string): void {
        this.UserSpecifiedDate = DateTimeHelper.formatDateTime(activityDate);
        this.UserSpecifiedDateOffset = DateTimeHelper.getUtcOffsetInMinutes(activityDate, timeZoneId);
        this.TimeZoneId = timeZoneId;
    }

    setForeignKeys(activityLogRecordId: number, referenceRecordId: number | null, entityTypeId: number, activityLogId: number | null, referenceId: number | null): void {
        this.ActivityLogRecordId = activityLogRecordId;
        this.ReferenceRecordId = referenceRecordId;
        this.EntityTypeId = entityTypeId;
        this.ActivityLogId = activityLogId;
        this.ReferenceId = referenceId;
    }

    setSoftDeleted(): void {
        this.IsDeleted = true;
    }

    isSoftDeleted(): boolean {
        return this.IsDeleted;
    }
}